import { useTranslation } from 'react-i18next'
import { cn } from '@sweetspot/scramble-ds/utils'

type SimulatorRangesConflictHeaderProps = {
  isConflict: boolean
  onCancel: () => void
}

const SimulatorRangesConflictHeader = ({
  isConflict,
  onCancel,
}: SimulatorRangesConflictHeaderProps) => {
  const { t } = useTranslation()

  return (
    <div
      className={cn(
        'pointer-events-none absolute left-0 right-0 top-0 z-[9] box-border h-full origin-top scale-y-0 overflow-hidden bg-white transition-transform',
        isConflict && 'pointer-events-auto relative h-20 scale-y-100 md:absolute md:h-full'
      )}
    >
      <div className={cn('flex h-full w-full items-center justify-start bg-red-400/20 px-[30px]')}>
        <span className={cn('material-icons-round md-32 md-red mr-3')}>warning</span>
        <p className={cn('text-sm font-medium text-red-500')}>
          {t('sentences.thereIsAConflictWithAnotherBooking')}
        </p>
        <span
          onClick={onCancel}
          className={cn(
            'material-icons md-32 md-red ml-auto scale-100 transition-transform hover:scale-110 hover:cursor-pointer'
          )}
        >
          close
        </span>
      </div>
    </div>
  )
}

export default SimulatorRangesConflictHeader
